import moment from 'moment'
import { fontFamily } from '../../utils/constant'

export const getAxisX = (startDate, endDate) => {
  const axisX = []
  let count = 1
  axisX.push(moment(startDate))
  while (
    moment(startDate)
      .add(count, 'days')
      .isBefore(endDate)
  ) {
    axisX.push(moment(startDate).add(count, 'days'))
    count++
  }
  axisX.push(moment(endDate))
  return axisX
}

export const xAxisFormat = (datum) =>
  moment(datum)
    .format('ddd')
    .toUpperCase()

export const sumReduce = (prev, curr) => {
  return prev + curr
}

export const splitLine = (datas) => {
  let solidGroup = [],
    dashGroup = []
  let startIndex = datas.findIndex((element) => element.y)
  const newDatas = datas.slice(startIndex)
  startIndex = 0
  newDatas.forEach((element, index) => {
    if (startIndex !== index || startIndex > newDatas.length - 1) {
      return
    }
    let subDatas = newDatas.slice(index)
    if (element.y) {
      let firstNullDataIndex = subDatas.findIndex((element) => {
        if (element.y) {
          return false
        }
        return true
      })
      let solid
      if (firstNullDataIndex === -1) {
        solid = subDatas
      } else {
        solid = subDatas.slice(0, firstNullDataIndex)
      }
      solidGroup.push(solid)
      startIndex = index + solid.length
    } else {
      let firstExistDataIndex = subDatas.findIndex((element) => {
        if (element.y) {
          return true
        }
        return false
      })
      if (firstExistDataIndex === -1) {
        return
      }
      let dash = [newDatas[index - 1], subDatas[firstExistDataIndex]]
      dashGroup.push(dash)
      startIndex = index + firstExistDataIndex
    }
  })
  return { solidGroup, dashGroup }
}

export const splitLineStyle = (datas) => {
  const existData = datas.filter((item) => item.y)
  let solidGroup = [],
    dashGroup = []
  for (const item of existData) {
    const length = solidGroup.length
    if (length === 0) {
      solidGroup.push([item])
    } else {
      const targetArray = solidGroup[length - 1]
      const target = targetArray[targetArray.length - 1]
      if (
        moment(target.x)
          .add(1, 'days')
          .isSame(moment(item.x))
      ) {
        targetArray.push(item)
      } else {
        solidGroup.push([item])
      }
    }
  }
  dashGroup = solidGroup.filter((item) => item.length === 1)
  solidGroup = solidGroup.filter((item) => item.length > 1)
  dashGroup = dashGroup.map((group) => {
    const target = group[0]
    const index = existData.findIndex(
      (item) =>
        item.x && item.x.format('YYYY-MM-DD') === target.x.format('YYYY-MM-DD')
    )
    if (index > 0) {
      group.unshift(existData[index - 1])
    }
    if (index < existData.length - 1) {
      group.push(existData[index + 1])
    }
    return group
  })
  return { solidGroup, dashGroup }
}

export const tickLabels = {
  fontFamily: `"Gilroy",${fontFamily}`,
  fontSize: '9px',
  fill: '#70808E'
}

export const calculateElementWidth = (tag, text, fontSize, width) => {
  const element = document.createElement(tag.toUpperCase())
  const style = `font-size: ${fontSize}; width: ${width ||
    'auto'};color: transparent; position: absolute;`
  element.setAttribute('style', style)
  element.innerText = text
  document.body.append(element)
  const elementWidth = element.offsetWidth,
    elementHeight = element.offsetHeight
  document.body.removeChild(element)
  return { width: elementWidth, height: elementHeight }
}

export const getFloat = (num, n) => {
  n = n ? parseInt(n) : 0
  if (n <= 0) {
    return Math.round(num)
  }
  num = Math.round(num * Math.pow(10, n)) / Math.pow(10, n)
  num = Number(num).toFixed(n)
  return num
}

// First value that is actually present. 0 counts as data, null/undefined don't.
export const firstDefined = (...values) =>
  values.find((value) => value !== undefined && value !== null)

// The platform (summary card) stores the average bed time as the amount of
// seconds elapsed since the beginning of the day before the record date, so it
// can be greater than 24h for bed times after midnight (e.g. 02:01 AM =>
// 93660s). Format it the same way the platform displays it: 'hh:mm A'.
export const formatBedtimeFromSeconds = (seconds) =>
  seconds > 0 ? moment.utc(seconds * 1000).format('hh:mm A') : null

// Merge the daily sleep details of the summary email payload with the ones of
// the platform (summary card). The email payload re-parses raw records and can
// miss or misreport in-bed time, bed time and resting heart rate, while
// `overview.entries` holds the same stored summaries the client detail page
// shows. The platform value wins whenever it exists, otherwise the email value
// is kept, so days without platform data still render.
export const mergeSleepDetails = (emailDetails, overview, tickValuesX) => {
  const details = emailDetails || []
  const entries = (overview && overview.entries) || []
  if (!Array.isArray(entries) || entries.length === 0) {
    return details
  }
  const hasSleepFields = (entry) =>
    entry.details &&
    (entry.details.inbed_time !== undefined ||
      entry.details.bedtime_start !== undefined ||
      entry.details.resting_heartrate !== undefined)
  return tickValuesX
    .map((date) => {
      const summaryDate = date.format('YYYY-MM-DD')
      const emailDetail = details.find(
        (detail) => detail.summary_date === summaryDate
      )
      const platformEntry = entries.find(
        (entry) =>
          entry.pillar === 'rejuvenation' &&
          !entry.manual &&
          entry.record_date === summaryDate &&
          hasSleepFields(entry)
      )
      if (!platformEntry) {
        return emailDetail
      }
      const platformDetails = platformEntry.details
      return {
        ...(emailDetail || { summary_date: summaryDate }),
        inbed_time: firstDefined(
          platformDetails.inbed_time,
          emailDetail && emailDetail.inbed_time
        ),
        bedtime_start: firstDefined(
          platformDetails.bedtime_start,
          emailDetail && emailDetail.bedtime_start
        ),
        bedtime_end: firstDefined(
          platformDetails.bedtime_end,
          emailDetail && emailDetail.bedtime_end
        ),
        resting_hr: firstDefined(
          platformDetails.resting_heartrate,
          emailDetail && emailDetail.resting_hr
        )
      }
    })
    .filter(Boolean)
}
